import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfigService, GuidService, LoggingService } from '@app-core';
import { Account } from '@app-models';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-header',
    imports: [NgbDropdownModule],
    templateUrl: './header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './header.component.scss',
})
export class HeaderComponent {
    private readonly appConfigService = inject(AppConfigService);
    private readonly router = inject(Router);
    private readonly guidService = inject(GuidService);
    public logo: string = 'assets/images/dewar-logo.svg';
    public account: Account;

    navigateHome() {
        const guid = this.guidService.getGuid();
        LoggingService.log('HeaderComponent', 'navigateHome', 'guid', guid);
        if (guid) {
            this.router.navigate(['parent-response'], { queryParams: { guid } });
        }
    }

    onKeyDown(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.navigateHome();
        }
    }
}
